module.exports = __webpack_public_path__ + "img/gambia.c497de91.svg";